import { text, index, uniqueIndex } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'
import { connectorInstances } from './connectors-instances'

// ============================================================================
// connectors_credentials — Encrypted credentials for an instance (AES-256-GCM)
//
// Only ciphertext is stored. `encryption_key_id` references the KMS/vault key
// used so we can rotate without re-fetching tokens from providers.
// ============================================================================
export const connectorCredentials = defineTable(
  'connectors',
  'credentials',
  {
    id: text('id').primaryKey(),
    instanceId: text('instance_id')
      .notNull()
      .references(() => connectorInstances.id, { onDelete: 'cascade' }),
    accessTokenEnc: text('access_token_enc').notNull(),
    refreshTokenEnc: text('refresh_token_enc'),
    expiresAt: text('expires_at'),
    refreshExpiresAt: text('refresh_expires_at'),
    scope: text('scope'),
    tokenType: text('token_type').notNull().default('bearer'),
    encryptionKeyId: text('encryption_key_id').notNull(),
    rotatedAt: text('rotated_at'),
    createdAt: text('created_at').notNull(),
    updatedAt: text('updated_at').notNull(),
  },
  (table) => [
    uniqueIndex('connectors_credentials_instance_unique').on(table.instanceId),
    index('connectors_credentials_expires_at_idx').on(table.expiresAt),
  ],
)

export type ConnectorCredential = typeof connectorCredentials.$inferSelect
export type NewConnectorCredential = typeof connectorCredentials.$inferInsert
